// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"346":"3031a48a","787":"cda612ba","841":"25fd0523"}[chunkId] + ".chunk.js";
};